import React from "react";
import { connect } from "react-redux";
import {
  PROVIDER_ROOM_PROCEDURE_TYPE,
  PROVIDER_ROOM_PROCEDURE_VERSION,
} from "../../../api/queries/useProviderRoomProceduresQuery";
import { useProcedures } from "../hooks/useProcedures";
import { TabCosmetic } from "./components/TabCosmetic";
import { TabHealth } from "./components/TabHealth";
import { TabInformation } from "./components/TabInformation";
import { useCancelSign } from "../hooks/useCancelSign";
import { Layout } from "../components/Layout/Layout";
import { useApiClinics } from "../../Event/hooks/useApiClinics";
import { providerRoom } from "../../../store/providerRoom";

function TabSentToMd({ history, activeTab }) {
  const { cancelSign, isSignCancelling } = useCancelSign();
  const historyData = history?.location?.state;
  const chartAuditUserId = historyData?.chartUserId?.toString();

  const {
    procedures,
    fetchNextProcedures,
    proceduresStatus,
    proceduresSearchTerm,
    proceduresType,
    selectClinic,
    subAction,
  } = useProcedures({
    version: PROVIDER_ROOM_PROCEDURE_VERSION.sentToMd,
    clinicID: historyData?.clinic_id,
    providerUserId: chartAuditUserId,
    activeProcedureTab: activeTab,
  });

  const { clinics: availableClinicsList } = useApiClinics();

  const tabByType = {
    [PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic]: (
      <TabCosmetic
        isVisible={proceduresStatus.isVisible}
        onChangeTab={proceduresType.onChange}
        procedures={procedures}
        unsend={cancelSign}
        isUnsending={isSignCancelling}
        availableClinicsList={availableClinicsList}
        onChangeClinic={selectClinic.onChange}
        clinicId={selectClinic.value}
        showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
        providerUserId={chartAuditUserId}
      />
    ),
    [PROVIDER_ROOM_PROCEDURE_TYPE.health]: (
      <TabHealth
        isVisible={proceduresStatus.isVisible}
        onChangeTab={proceduresType.onChange}
        procedures={procedures}
        unsend={cancelSign}
        isUnsending={isSignCancelling}
        availableClinicsList={availableClinicsList}
        onChangeClinic={selectClinic.onChange}
        clinicId={selectClinic.value}
        showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
        providerUserId={chartAuditUserId}
      />
    ),
    [PROVIDER_ROOM_PROCEDURE_TYPE.information]: (
      <TabInformation
        isVisible={proceduresStatus.isVisible}
        onChangeTab={proceduresType.onChange}
        procedures={procedures}
        availableClinicsList={availableClinicsList}
        onChangeClinic={selectClinic.onChange}
        clinicId={selectClinic.value}
        showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
        providerUserId={chartAuditUserId}
        subAction={subAction}
      />
    ),
  };

  return (
    <Layout
      search={proceduresSearchTerm}
      status={proceduresStatus}
      loadMore={fetchNextProcedures}
    >
      {tabByType[activeTab]}
    </Layout>
  );
}

function mapStateToProps(state) {
  return {
    activeTab: providerRoom.selectors.selectCurrentTab(state),
  };
}
export default connect(mapStateToProps)(TabSentToMd);
